import {
  Tile,
  TileContent,
  TileMedia,
  TileText,
  TileTitle,
} from '@design-system';
import Link from 'next/link';

import { TrackLinkClicked } from '../../../utils/analytics';
import { Image } from '../../Image';

export const ArtistTileInline = ({
  artist,
  overline,
  page,
}: {
  artist: {
    name: string;
    slug: string;
    thumbnail: {
      alt: string;
      filename: string;
      focus?: string;
    };
  };
  overline?: string;
  page: string;
}) => {
  return (
    <Tile className="group" direction="row">
      <TileMedia className="size-12 shrink-0">
        <Image
          alt={artist.thumbnail.alt}
          focus={artist.thumbnail.focus}
          hoverEffect
          src={artist.thumbnail.filename}
          width={128}
        />
      </TileMedia>
      <TileContent className="w-full" direction="column">
        <TileTitle>
          <Link
            data-testid={`artist-tile-${artist.name.toLowerCase()}`}
            href={`/${artist.slug}`}
            onClick={() => {
              void TrackLinkClicked({
                page: page || '',
                context: 'artist tile',
                title: artist.name || '',
                url: artist.slug || '',
                isExternal: false,
              });
            }}
            prefetch={false}
            className="after:absolute after:inset-0 after:block after:content-['']"
          >
            {artist.name}
          </Link>
        </TileTitle>
        {overline ? <TileText>{overline}</TileText> : null}
      </TileContent>
    </Tile>
  );
};
